// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";

import { mdiInformationOutline } from "@mdi/js";

// Shared content for the "Calculate job?" confirm dialog, used by both the geo
// calculation and geo simulation job tables so the two dialogs never drift.

// Every Calculate confirm shows the same message — the failure reason lives on
// the status pill and the affected-items list is emailed.
export const calculateReportNotice = (
  <p>A report will be emailed to you and the job owner when the job finishes.</p>
);

// Primary-colored info icon for the confirm title (antd's default confirm icon
// is a warning glyph). currentColor on the span drives the mdi icon's fill.
export const calculateInfoIcon = (
  <span className="anticon" style={{ color: "var(--color-primary)" }}>
    <Icon path={mdiInformationOutline} size={1.5} />
  </span>
);
